import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { postContactoEmpresa } from '../services/api';
import { toast } from 'react-toastify';
import '../styles/styles.css';
import { formatPhone } from '../utils/phone';


const CrearContactoEmpresa = () => {
    const { empresaId } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        nombre: '',
        email: '',
        telefono: '',
        cargo: ''
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if(name === 'telefono'){
            setFormData((prev) => ({ ...prev, [name]: formatPhone(value) }));
        }else{
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await postContactoEmpresa(empresaId, formData);
            navigate(`/empresas/${empresaId}`);
        } catch (err) {
            console.error('Error al crear contacto:', err);
            toast.error('No se pudo crear el contacto');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="content-wrapper">
                <h1>Crear Contacto</h1>
                <div className="container">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Nombre</label>
                            <input
                                type="text"
                                name="nombre"
                                value={formData.nombre}
                                onChange={handleChange}
                                className="form-control"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label>Teléfono</label>
                            <div className="phone-input-group">
                                <span className="phone-prefix">+56</span>
                                <input
                                    type="tel"
                                    name="telefono"
                                    value={formData.telefono}
                                    onChange={handleChange}
                                    maxLength={9}
                                    size={16}
                                    placeholder="912345678"
                                    className="phone-input-field"
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Cargo</label>
                            <input
                                type="text"
                                name="cargo"
                                value={formData.cargo}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <button type="submit" className="btn btn-create" disabled={loading}>
                                {loading ? 'Creando...' : 'Guardar'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );

};

export default CrearContactoEmpresa;